import { ContactPersonManager } from '@ayocore/erp/crm/client/components/ContactPersonManager';
import type { ContactPerson } from '../../../../../schemas/contact-person.schema';

interface LeadContactPersonsProps {
  entityId: number;
  entityType: 'crm::PartnerRepository' | 'crm::LeadRepository';
  contactPersons: ContactPerson[];
  onContactPersonsChanged: () => void;
}

export function LeadContactPersons({
  entityId,
  entityType,
  contactPersons,
  onContactPersonsChanged,
}: LeadContactPersonsProps) {
  return (
    <ContactPersonManager
      entityId={entityId}
      entityType={entityType}
      contactPersons={contactPersons}
      onContactPersonsChanged={onContactPersonsChanged}
    />
  );
}
